/* generated by pull.js */
const manifest = {
  "editorOnly": true,
  "name": "Collaborative editing",
  "description": "Editing projects with others in real time!",
  "credits": [
    {
      "name": "KOSHINO",
      "link": "https://github.com/KOSHINOawa"
    }
  ],
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "userstyles": [
    {
      "url": "style.css"
    }
  ],
  "tags": [
    "new"
  ],
  "dynamicDisable": true,
  "enabledByDefault": true
};
export default manifest;
